import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { api } from "../api/client";
import { FormGroup } from "../components/UI";

const TYPEN = [
  { value: "beschlussvorlage", label: "Beschlussvorlage" },
  { value: "informationsvorlage", label: "Informationsvorlage" },
  { value: "mitteilung", label: "Mitteilung" },
  { value: "antrag", label: "Antrag" },
  { value: "aenderungsantrag", label: "Änderungsantrag" },
  { value: "anfrage", label: "Anfrage" },
  { value: "bericht", label: "Bericht" },
];

export default function VorlageForm() {
  const { id } = useParams();
  const navigate = useNavigate();
  const bearbeiten = !!id;

  const [form, setForm] = useState({
    typ: "beschlussvorlage", titel: "", kurzbeschreibung: "", sachverhalt: "",
    begruendung: "", beschlussvorschlag: "", finanzielle_auswirkungen: "", zustaendige_stelle: "",
  });
  const [gesperrt, setGesperrt] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (bearbeiten) {
      api.getVorlage(id).then(v => {
        setForm(v);
        setGesperrt(v.status !== "entwurf");
      });
    }
  }, [id, bearbeiten]);

  const set = (k, val) => setForm(f => ({ ...f, [k]: val }));

  const speichern = async () => {
    setError("");
    try {
      if (bearbeiten) {
        await api.updateVorlage(id, form);
        navigate(`/vorlagen/${id}`);
      } else {
        const v = await api.createVorlage(form);
        navigate(`/vorlagen/${v.id}`);
      }
    } catch {
      setError("Fehler beim Speichern.");
    }
  };

  return (
    <div style={{ padding: 24, maxWidth: 700 }}>
      <h1 style={{ fontSize: 20, fontWeight: 700, marginBottom: 20 }}>
        {bearbeiten ? "Vorlage bearbeiten" : "Neue Vorlage"}
      </h1>

      {error && <div style={{ background: "var(--danger-bg)", color: "var(--danger)", padding: "10px 14px", borderRadius: 6, marginBottom: 16 }}>{error}</div>}
      {gesperrt && (
        <div style={{ background: "#fff8e1", color: "#f57f17", padding: "10px 14px", borderRadius: 6, marginBottom: 16, fontSize: 13 }}>
          Diese Vorlage ist bereits freigegeben und kann nicht mehr bearbeitet werden - zurückziehen, um sie zu ändern.
        </div>
      )}

      <div className="card" style={{ padding: 20 }}>
        <FormGroup label="Typ">
          <select className="form-control" value={form.typ} disabled={gesperrt} onChange={e => set("typ", e.target.value)}>
            {TYPEN.map(t => <option key={t.value} value={t.value}>{t.label}</option>)}
          </select>
        </FormGroup>
        <FormGroup label="Titel">
          <input className="form-control" value={form.titel} disabled={gesperrt} onChange={e => set("titel", e.target.value)} required />
        </FormGroup>
        <FormGroup label="Kurzbeschreibung">
          <textarea className="form-control" rows={2} value={form.kurzbeschreibung || ""} disabled={gesperrt} onChange={e => set("kurzbeschreibung", e.target.value)} />
        </FormGroup>
        <FormGroup label="Sachverhalt">
          <textarea className="form-control" rows={4} value={form.sachverhalt || ""} disabled={gesperrt} onChange={e => set("sachverhalt", e.target.value)} />
        </FormGroup>
        <FormGroup label="Begründung">
          <textarea className="form-control" rows={3} value={form.begruendung || ""} disabled={gesperrt} onChange={e => set("begruendung", e.target.value)} />
        </FormGroup>
        <FormGroup label="Beschlussvorschlag">
          <textarea className="form-control" rows={3} value={form.beschlussvorschlag || ""} disabled={gesperrt} onChange={e => set("beschlussvorschlag", e.target.value)} />
        </FormGroup>
        <FormGroup label="Finanzielle Auswirkungen">
          <textarea className="form-control" rows={2} value={form.finanzielle_auswirkungen || ""} disabled={gesperrt} onChange={e => set("finanzielle_auswirkungen", e.target.value)} />
        </FormGroup>
        <FormGroup label="Zuständige Stelle">
          <input className="form-control" value={form.zustaendige_stelle || ""} disabled={gesperrt} onChange={e => set("zustaendige_stelle", e.target.value)} />
        </FormGroup>

        {!gesperrt && (
          <div style={{ display: "flex", gap: 8, marginTop: 16 }}>
            <button className="btn btn-secondary" onClick={() => navigate(-1)}>Abbrechen</button>
            <button className="btn btn-primary" onClick={speichern}>Speichern</button>
          </div>
        )}
      </div>
    </div>
  );
}
